import script from "./ModernBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./ModernBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./ModernBreadcrumb.vue?vue&type=style&index=0&id=1f51128e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f51128e"]])

export default __exports__